var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.49,
    height: 72.272,
    viewBox: "0 0 81.49 72.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628",
    transform: "translate(-366 -377.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564",
    transform: "translate(17452.902 -14780.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wedding-location",
    transform: "translate(-17086.902 15167.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6837",
    "data-name": "Path 6837",
    d: "M81.362,120.813,75.915,109.92,69.378,96.847a1.207,1.207,0,0,0-.1-.166,1.186,1.186,0,0,0-.969-.5H55.65c.768-1.423,1.481-2.868,2.128-4.319A48.429,48.429,0,0,0,60.185,85.3a22.74,22.74,0,0,0,.93-5.889A19.091,19.091,0,0,0,57.11,67.676a.1.1,0,0,1-.011-.016l0,0a19.236,19.236,0,0,0-6.579-5.4,19.044,19.044,0,0,0-4.1-1.492,19.266,19.266,0,0,0-4.472-.526h0a19.1,19.1,0,0,0-12.156,4.347A1.2,1.2,0,0,0,31.3,66.433a16.754,16.754,0,0,1,21.3.021,16.738,16.738,0,0,1,6.116,12.954,25.978,25.978,0,0,1-1.892,8.45,59.272,59.272,0,0,1-4.192,8.806,1.2,1.2,0,0,0-.149.258,54.857,54.857,0,0,1-3.187,4.87,28.577,28.577,0,0,1-4.248,4.745c-.644.548-.937.746-1.52,1.175-.031.016-.433.226-.463.24l-.257.154-.868.463-.746-.343-.481-.275c-.212-.1-1.047-.733-1.27-.875-1.374-.86-2.428-2.141-4.131-4.327A52.8,52.8,0,0,1,31.4,96.922a1.2,1.2,0,0,0-.153-.263A62.048,62.048,0,0,1,28.3,90.89c-2-4.472-3.143-8.657-3.133-11.481a16.68,16.68,0,0,1,3.1-9.713,1.2,1.2,0,0,0-1.954-1.39,19.093,19.093,0,0,0-3.537,11.1,27.9,27.9,0,0,0,2.04,9.284,60.874,60.874,0,0,0,3.427,7.492H13.182a1.2,1.2,0,0,0-1.072.662l-2.4,4.793h0l-4.793,9.586h0L.127,120.814A1.2,1.2,0,0,0,1.2,122.548H80.29a1.2,1.2,0,0,0,1.072-1.735ZM13.923,98.582h4.51l-1.2,2.4h-4.51Zm-1.481,21.57h-9.3l3.6-7.19h9.3Zm2.68,0,3.926-7.852a1.2,1.2,0,0,0-1.072-1.734H7.931l3.6-7.19h6.449a1.2,1.2,0,0,0,1.072-.662l2.065-4.131H29.6c.984,1.65,2.021,3.224,3.06,4.635a30.913,30.913,0,0,0,4.626,5.15,11.788,11.788,0,0,0,2.294,1.569,10.847,10.847,0,0,0,1.619.714,6.476,6.476,0,0,0,.746.257c.106,0,.827-.253.868-.257a9.259,9.259,0,0,0,2.263-1.148,16.248,16.248,0,0,0,2.683-2.2,33.078,33.078,0,0,0,2.7-3.077,54.311,54.311,0,0,0,3.83-5.646h6.086L69.884,117.6a1.2,1.2,0,0,0,2.144-1.072,0,0,0,0,0,0,0L63.055,98.582h4.51l10.784,21.57H15.121Z",
    transform: "translate(0 -60.234)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(23.967 45.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1562",
    "data-name": "Group 1562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6839",
    "data-name": "Path 6839",
    d: "M186.475,354.361l-2.4-7.19a1.2,1.2,0,0,0-1.137-.819h-4.58a1.2,1.2,0,1,0,0,2.4h3.717l1.6,4.793H153.447l1.6-4.793h3.719a1.2,1.2,0,1,0,0-2.4h-4.583a1.2,1.2,0,0,0-1.137.819l-2.4,7.19a1.2,1.2,0,0,0,1.137,1.577h33.554a1.2,1.2,0,0,0,1.137-1.577Z",
    transform: "translate(-150.586 -346.352)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1056",
    "data-name": "Ellipse 1056",
    transform: "translate(-17054 15177)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.5,
    rx: 9,
    ry: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.5,
    rx: 7.5,
    ry: 8,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6730",
    "data-name": "Path 6730",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(426.898 253.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6727",
    "data-name": "Path 6727",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(376.898 288.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6729",
    "data-name": "Path 6729",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(350.512 342.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6840",
    "data-name": "Path 6840",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(411.512 373.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6728",
    "data-name": "Path 6728",
    d: "M160.169,173.9v2.8h-2.8v-2.8Zm0,5.6v2.8h-2.8v-2.8Z",
    transform: "translate(273.309 235.954)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.61930c55924c71f3dfd5ac173f1c37d8.svg";
export { ForwardRef as ReactComponent };